import { FormControl, MenuItem, Select } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const DescriptionDetails: React.FunctionComponent<{ property: any, errors: any, onChangeDesc: any }> = (props) => {
    
    const { t } = useTranslation();

    const handleChangeDescTitle = (event: any) => {
        props.onChangeDesc(event)
    }

    return (
        <>
            <div className="col-md-4 mb-3">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.length")} *</label>
                <FormControl fullWidth>
                    <Select
                        className={`input-property ${props.errors.desclength ? 'input-error' : ''}`}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        value={props.property.descriptionTitle?.length || ''}
                        name="length"
                        onChange={handleChangeDescTitle}
                    >
                        <MenuItem value="" disabled>
                            {t("propertiesPage.select")}
                        </MenuItem>
                        <MenuItem value={"Short and Concise"}>{t("descriptionDetails.shortAndConcise")}</MenuItem>
                        <MenuItem value={"Medium length"}>{t("descriptionDetails.mediumLength")}</MenuItem>
                        <MenuItem value={"Detailed and Elaborate"}>{t("descriptionDetails.detailedAndElaborate")}</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 mb-3">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.tone")} *</label>
                <FormControl fullWidth>
                    <Select
                        className={`input-property ${props.errors.tone ? 'input-error' : ''}`}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        value={props.property.descriptionTitle?.tone || ''}
                        name="tone"
                        onChange={handleChangeDescTitle}>
                        <MenuItem value="" disabled> {t("propertiesPage.select")} </MenuItem>
                        <MenuItem value={"Formal and Professional"}>{t("descriptionDetails.formalAndProfessional")}</MenuItem>
                        <MenuItem value={"Friendly and Welcoming"}>{t("descriptionDetails.friendlyAndWelcoming")}</MenuItem>
                        <MenuItem value={"Luxurious and Indulgent"}>{t("descriptionDetails.luxuriousAndIndulgent")}</MenuItem>
                        <MenuItem value={"Cozy and Inviting"}>{t("descriptionDetails.cozyAndInviting")}</MenuItem>
                        <MenuItem value={"Informative and Descriptive"}>{t("descriptionDetails.informativeAndDescriptive")}</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 mb-3">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.style")} *</label>
                <FormControl fullWidth>
                    <Select
                        className={`input-property ${props.errors.style ? 'input-error' : ''}`}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        value={props.property.descriptionTitle?.style || ''}
                        name="style"
                        onChange={handleChangeDescTitle}>
                        <MenuItem value="" disabled> {t("propertiesPage.select")} </MenuItem>
                        <MenuItem value={"Modern and Sleek"}>{t("descriptionDetails.modernAndSleek")}</MenuItem>
                        <MenuItem value={"Classic and Elegant"}>{t("descriptionDetails.classicAndElegant")}</MenuItem>
                        <MenuItem value={"Rustic and Charming"}>{t("descriptionDetails.rusticAndCharming")}</MenuItem>
                    </Select>
                </FormControl>
            </div>
            {/* <div className="col-md-6">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.description")}</label>
                <div className="d-flex">
                    <div className="col-1 mb-3 marg-right-5">
                        <label className="form-label-2 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.minCharacters")}</label>
                        <input type="number" min="0" className={`form-input ${props.errors.minCharactersDesc ? 'input-error' : ''}`} placeholder={t("descriptionDetails.minCharacters")} name="minCharactersDesc"
                            onChange={handleChangeDescTitle} value={props.property.descriptionTitle?.minCharactersDesc || ""} />
                    </div>
                    <div className="col-1 mb-3 marg-left-5">
                        <label className="form-label-2 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.maxCharacters")}</label>
                        <input type="number" min="0" className={`form-input ${props.errors.maxCharactersDesc ? 'input-error' : ''}`} placeholder={t("descriptionDetails.maxCharacters")} name="maxCharactersDesc"
                            onChange={handleChangeDescTitle} value={props.property.descriptionTitle?.maxCharactersDesc || ""} />
                    </div>
                </div>
            </div>
            <div className="col-md-6">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.title")}</label>
                <div className="d-flex">
                    <div className="col-1 mb-3 marg-right-5">
                        <label className="form-label-2 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.minCharacters")}</label>
                        <input type="number" min="0" className={`form-input  ${props.errors.minCharactersTitle ? 'input-error' : ''}`} placeholder={t("descriptionDetails.minCharacters")} name="minCharactersTitle"
                            onChange={handleChangeDescTitle} value={props.property.descriptionTitle?.minCharactersTitle || ""} />
                    </div>
                    <div className="col-1 mb-3 marg-left-5">
                        <label className="form-label-2 mb-2" htmlFor="selectTypeOpt">{t("descriptionDetails.maxCharacters")}</label>
                        <input type="number" min="0" className={`form-input  ${props.errors.maxCharactersTitle ? 'input-error' : ''}`} placeholder={t("descriptionDetails.maxCharacters")} name="maxCharactersTitle"
                            onChange={handleChangeDescTitle} value={props.property.descriptionTitle?.maxCharactersTitle || ""} />
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default DescriptionDetails;